export const AppConfig = {
  mapbox: {
    token: 'pk.eyJ1IjoiYWZpbmttaWxsZXIiLCJhIjoiY2ptem5oZm50NDFmMjNwcWNrbDdtczQ4bSJ9.W8K3McOA8nkCnwfM2jJ3Rg',
    style: 'mapbox://styles/afinkmiller/cjmzmiw7d35qe2sprmafo3eb9',
    defaultZoom: 14,
  }
};
